import { usePurchaseButtonContext } from './Context'
import { useHistory } from '@ztechapps/common.hook'
import { Alert, EmptyContent, ShowIf } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'
import type { RouteDef } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export const Confirm = ({ toggleShowModal }: { toggleShowModal?: () => void }) => {
  const { useErrorResult, actionType, setShowConfirm, purchaseOrderResult, onAfterAction } = usePurchaseButtonContext()
  const { error } = useErrorResult
  const history = useHistory()
  const purchaseOrderRoute = useInject<RouteDef>(WebuiIocKey.routes.purchaseOrderItem)

  const sucessMessage =
    actionType === 'add-new'
      ? `Successfully added to new purchase order ${purchaseOrderResult?.code} .`
      : 'Successfully added to existing purchase order.'

  const onClose = () => {
    toggleShowModal()
    setShowConfirm(false)
    onAfterAction?.()
  }
  const onGoToPurchaseOrder = () => {
    onClose()
    const purchaseOrderId = purchaseOrderResult?._id
    const url = purchaseOrderRoute?.altPath?.({ _id: purchaseOrderId })
    history.push(url)
  }

  return (
    <>
      <ShowIf condition={!!error}>
        <Alert style={{ marginBottom: 0 }}>
          <EmptyContent
            icon={null}
            message="Un-expected error occurred."
            subMessage={
              <Stack className="justify-content-center align-items-center">
                <div>{error}</div>
                <div>Please try again later.</div>
              </Stack>
            }
            action={
              <ButtonGroup>
                <BusyButton variant="secondary" text="Close" icon="ban" onClick={onClose}></BusyButton>
              </ButtonGroup>
            }
          />
        </Alert>
      </ShowIf>
      <ShowIf condition={!error}>
        <Alert type="success" style={{ marginBottom: 0 }}>
          <EmptyContent
            icon={null}
            message="Success!"
            subMessage={sucessMessage}
            action={
              <ButtonGroup>
                <BusyButton variant="primary" text="Go to the purchase order" onClick={onGoToPurchaseOrder} />
                <BusyButton variant="secondary" text="Close" icon="ban" onClick={onClose}></BusyButton>
              </ButtonGroup>
            }
          />
        </Alert>
      </ShowIf>
    </>
  )
}
